export default __webpack_public_path__ + "static/media/example-profile-photo-2.b46c941d.png";